import * as React from 'react'

function IconOvalBlocked({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={145}
      viewBox="0 0 104 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter0_oval)">
            <path
              d="M101.5 71.5c0 19.652-5.683 37.423-14.844 50.268C77.493 134.614 64.88 142.5 51 142.5c-13.88 0-26.492-7.886-35.655-20.732C6.183 108.923.5 91.152.5 71.5s5.683-37.423 14.845-50.268C24.507 8.386 37.12.5 51 .5c13.88 0 26.493 7.886 35.656 20.732C95.817 34.077 101.5 51.848 101.5 71.5z"
              stroke="#fff"
            />
            <path
              d="M51 143c28.167 0 51-32.012 51-71.5S79.167 0 51 0C22.834 0 0 32.012 0 71.5S22.834 143 51 143z"
              fill="#A2A2A2"
            />
            <path
              d="M51 134.642c-23.536 0-42.703-28.35-42.703-63.17s19.14-63.17 42.704-63.17c23.536 0 42.702 28.35 42.702 63.17 0 34.848-19.139 63.17-42.703 63.17z"
              stroke="#fff"
              strokeWidth={0.75}
              strokeMiterlimit={10}
            />
            <path
              d="M38.981 59.019l24.284 25.164M63.265 59.019L38.981 84.183"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_oval"
              x={0}
              y={0}
              width={102}
              height={143}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M51 142c27.614 0 50-31.564 50-70.5S78.614 1 51 1 1 32.564 1 71.5 23.386 142 51 142z"
            fill="#fff"
          />
          <path
            d="M51 142c27.614 0 50-31.564 50-70.5S78.614 1 51 1 1 32.564 1 71.5 23.386 142 51 142z"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M51 133.759c-23.075 0-41.866-27.954-41.866-62.286C9.134 37.14 27.898 9.185 51 9.185c23.075 0 41.866 27.954 41.866 62.286 0 34.361-18.764 62.287-41.866 62.287z"
            fill="#A2A2A2"
          />
          <path
            d="M39.217 59.193l23.807 24.812M63.024 59.193L39.217 84.005"
            stroke="#fff"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconOvalBlocked
